// checkbox-label.component.ts
import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-checkbox-label',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <label class="flex items-center gap-3 w-full cursor-pointer" [class.opacity-50]="disabled">
      <div class="relative w-5 h-5 flex items-center justify-center">
        <div *ngIf="value" class="fas fa-square-check text-theme fa-lg">
        </div>
        <div *ngIf="!value" class="far fa-square text-theme fa-lg">
        </div>
        <input type="checkbox" [checked]="value" (click)="onInputChange($event)" class="hidden">
      </div>
      <ng-content></ng-content>
    </label>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxLabelComponent),
      multi: true
    }
  ]
})
export class CheckboxLabelComponent implements ControlValueAccessor {
  value = false;
  disabled = false;
  onChange: any = () => {};

  writeValue(value: boolean): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    // Required by interface but unused
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: Event): void {
    event.stopPropagation();
    if (!this.disabled) {
      this.value = !this.value;
      this.onChange(this.value);
    }
  }
}
